
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/elections/2022/races/president-vice-president/index-default",
      function () {
        return require("private-next-pages/elections/2022/races/president-vice-president/index-default.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/elections/2022/races/president-vice-president/index-default"])
      });
    }
  